import * as React from 'react';
import ForwardIcon from '../assets/images/forward.svg';
import BackwardIcon from '../assets/images/backward.svg';

import './Drawer.scss';

export interface IProps {
  	toggleDrawer?: () => void;
	expanded?: boolean;
    children?: JSX.Element | JSX.Element[],
	className?: string;
}

export const Drawer: React.FC<IProps> = ({ expanded, className, children, toggleDrawer }) => {
	return (
		<div className={`edl-drawer ${expanded ? 'expanded' : 'collapsed'} ${className ? className : ''}`}>
      		<div className='edl-drawer-content-container'>
				{children}
				<div onClick={toggleDrawer} className='edl-drawer-toggle-button' data-test-id='toggle-drawer-button'>
					<img className='edl-drawer-toggle-button-icon' alt='toggle drawer' src={ expanded ? BackwardIcon : ForwardIcon } />
				</div>
			</div>
		</div>
	);
};
